import { Directive, HostBinding, HostListener, inject, Input } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { PreviewAttachmentDialogComponent, PreviewImageAttachmentDialogData } from '../../attachment-preview-dialog';

@Directive({
  selector: '[libPreviewImage]',
  standalone: false,
})
export class PreviewImageDirective {
  @Input() public fileId?: string;
  @Input() public file?: File;
  @Input() public libPreviewImage!: string;
  @Input() public showPreview = true;

  private readonly dialog = inject(Dialog);

  @HostListener('click') public open(): void {
    if (!this.showPreview) {
      return;
    }

    this.dialog.open<PreviewAttachmentDialogComponent, PreviewImageAttachmentDialogData>(PreviewAttachmentDialogComponent, {
      hasBackdrop: true,
      backdropClass: ['bg-overlay-light', 'backdrop-blur', 'collab-image-backdrop'],
      height: '80vh',
      width: '80vw',
      data: {
        type: 'image',
        id: this.fileId,
        file: this.file,
        fileData: {
          imageUrl: this.libPreviewImage,
        },
      },
    });
  }

  @HostBinding('class') public cursorBinding = 'cursor-pointer';
}
